import React from "react"
import Slider from "react-slick"
import * as SelectionFactoryHelper from "../../helpers/SelectionFactoryHelper"
import DesignElementCard from "./design-element-card"
import useWindowWidth from "../../../hooks/useWindowWidth"

export default function DesignElementCardContainerBlockComponent({
  backgroundColor,
  bottomPadding,
  topPadding,
  header,
  designCards,
  clipBoardText,
  clipBoardCopiedText,
  enableCarousel,
  enableClipboard,
}) {
  const windowWidth = useWindowWidth()

  const tp = topPadding && topPadding[0] && SelectionFactoryHelper.getFromSelectionFactory(topPadding)
  const bp = bottomPadding && bottomPadding[0] && SelectionFactoryHelper.getFromSelectionFactory(bottomPadding)
  const bgc = backgroundColor && backgroundColor[0] && SelectionFactoryHelper.getFromSelectionFactory(backgroundColor)

  const dcs =
    designCards &&
    designCards.length > 0 &&
    designCards.map((c) => (
      <DesignElementCard
        key={c.image}
        clipBoardValue={c.clipBoardValue}
        clipBoardText={clipBoardText}
        clipBoardCopiedText={clipBoardCopiedText}
        designText={c.designText}
        image={c.image}
        enableClipboard={enableClipboard}
        designImageAltText={c.designImageAltText}
      />
    ))

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 150,
    swipe: true,
    variableWidth: false,
  }

  return (
    <div className={`design-card-component-container` + `${bgc ? " " + bgc : ""}` + `${tp ? " " + tp : ""}` + `${bp ? " " + bp : ""}`}>
      <div className={`design-card-component w--wider`}>
        {header ? (
          <div className="design-card-header">
            <h2 className="heading">{header}</h2>
          </div>
        ) : null}
        {windowWidth > 950 && enableCarousel && dcs && dcs.length > 4 ? (
          <Slider {...settings}>{dcs}</Slider>
        ) : (
          <div className="design-card-container">{dcs}</div>
        )}
      </div>
    </div>
  )
}
